import { HasFactoryWaterMark, MakeFactory } from '../../../classes/class-helpers/factory';
import { ConstructClassWithPrivateMembers } from '../../helpers/ClassWithPrivateMembers';
import { IsObject } from '../../../helpers';
import { BaseClass } from '../../../classes/class-helpers/base-class';
export const ASYNC_ITERATOR_PRIVATE = Symbol('async-iterator-private');
export function ConstructAsyncIterator(instance, next) {
    ConstructClassWithPrivateMembers(instance, ASYNC_ITERATOR_PRIVATE);
    const privates = instance[ASYNC_ITERATOR_PRIVATE];
    privates.next = next;
    privates.done = false;
    privates.nextPromise = Promise.resolve(void 0);
}
export function IsAsyncIterator(value) {
    return IsObject(value)
        && value.hasOwnProperty(ASYNC_ITERATOR_PRIVATE);
}
const IS_ASYNC_ITERATOR_CONSTRUCTOR = Symbol('is-async-iterator-constructor');
export function IsAsyncIteratorConstructor(value, direct) {
    return (typeof value === 'function') && ((value === AsyncIteratorClass) || HasFactoryWaterMark(value, IS_ASYNC_ITERATOR_CONSTRUCTOR, direct));
}
export function AsyncIteratorGetDone(instance) {
    return instance[ASYNC_ITERATOR_PRIVATE].done;
}
export function AsyncIteratorNext(instance, value) {
    const privates = instance[ASYNC_ITERATOR_PRIVATE];
    return privates.nextPromise = privates.nextPromise
        .then(() => {
        if (privates.done) {
            return AsyncIteratorGenerateDoneIteratorResult();
        }
        else {
            return new Promise(resolve => resolve(privates.next(value)))
                .then((result) => {
                if ((typeof result === 'object')
                    && (result !== null)
                    && ('done' in result)
                    && ('value' in result)) {
                    if (result.done) {
                        privates.done = true;
                    }
                    return result;
                }
                else {
                    privates.done = true;
                    throw new TypeError(`iterator.next() returned a non-object value`);
                }
            }, (error) => {
                privates.done = true;
                throw error;
            });
        }
    }, () => {
        privates.done = true;
        return AsyncIteratorGenerateDoneIteratorResult();
    });
}
export function AsyncIteratorReturn(instance, value) {
    return instance[ASYNC_ITERATOR_PRIVATE].nextPromise = instance[ASYNC_ITERATOR_PRIVATE].nextPromise
        .then(() => AsyncIteratorReturnInternal(instance, value), () => AsyncIteratorReturnInternal(instance, value));
}
export function AsyncIteratorThrow(instance, error) {
    return instance[ASYNC_ITERATOR_PRIVATE].nextPromise = instance[ASYNC_ITERATOR_PRIVATE].nextPromise
        .then(() => AsyncIteratorThrowInternal(instance, error), () => AsyncIteratorThrowInternal(instance, error));
}
export function AsyncIteratorReturnInternal(instance, value) {
    instance[ASYNC_ITERATOR_PRIVATE].done = true;
    return AsyncIteratorGenerateDoneIteratorResult(value);
}
export function AsyncIteratorThrowInternal(instance, error) {
    instance[ASYNC_ITERATOR_PRIVATE].done = true;
    throw error;
}
export function AsyncIteratorGenerateValueIteratorResult(value) {
    return {
        value: value,
        done: false,
    };
}
export function AsyncIteratorGenerateDoneIteratorResult(value) {
    return {
        value: value,
        done: true
    };
}
function PureAsyncIteratorFactory(superClass) {
    return class AsyncIterator extends superClass {
        constructor(...args) {
            const [next] = args[0];
            super(...args.slice(1));
            ConstructAsyncIterator(this, next);
        }
        get done() {
            return AsyncIteratorGetDone(this);
        }
        next(value) {
            return AsyncIteratorNext(this, value);
        }
        return(value) {
            return AsyncIteratorReturn(this, value);
        }
        throw(error) {
            return AsyncIteratorThrow(this, error);
        }
        [Symbol.asyncIterator]() {
            return this;
        }
    };
}
export let AsyncIteratorClass;
export function AsyncIteratorFactory(superClass) {
    return MakeFactory(PureAsyncIteratorFactory, [], superClass, {
        name: 'AsyncIteratorClass',
        instanceOf: AsyncIteratorClass,
        waterMarks: [IS_ASYNC_ITERATOR_CONSTRUCTOR]
    });
}
AsyncIteratorClass = class AsyncIterator extends AsyncIteratorFactory(BaseClass) {
    constructor(next) {
        super([next]);
    }
};
//# sourceMappingURL=implementation.js.map